import React, { useRef, useState, useEffect } from 'react';
import './TrophyAchievements.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { API_BASE, mediaSrc } from '../utils/api';
import 'swiper/css';
import 'swiper/css/navigation';

/**
 * API'den kupa gelmezse bölüm boşalmasın diye sitede yıllardır gösterilen liste.
 * Sunucudaki tohum kayıtları da bununla birebir aynı.
 */
const FALLBACK_TROPHIES = [
  { id: 'fb-1', title: 'Türkiye Şampiyonluğu', category: 'FUTBOL', count: 28, image: '/trophies/achievements-img1.png' },
  { id: 'fb-2', title: 'Türkiye Kupası', category: 'FUTBOL', count: 7, image: '/trophies/achievements-img2.png' },
  { id: 'fb-3', title: 'Türkiye Süper Kupası', category: 'FUTBOL', count: 9, image: '/trophies/achievements-img3.png' },
  { id: 'fb-4', title: 'Başbakanlık Kupası', category: 'FUTBOL', count: 8, image: '/trophies/achievements-img4.png' },
  { id: 'fb-5', title: 'Atatürk Kupası', category: 'FUTBOL', count: 2, image: '/trophies/achievements-img5.png' },
  { id: 'fb-6', title: 'İstanbul Ligi', category: 'FUTBOL', count: 16, image: '/trophies/achievements-img6.png' },
  { id: 'fb-7', title: 'İstanbul Şildi', category: 'FUTBOL', count: 4, image: '/trophies/achievements-img7.png' },
  { id: 'fb-8', title: 'İstanbul Kupası', category: 'FUTBOL', count: 1, image: '/trophies/achievements-img8.png' },
  { id: 'fb-9', title: 'Balkan Kupası', category: 'FUTBOL', count: 1, image: '/trophies/balkan.png' },
  { id: 'fb-10', title: 'General Harington Kupası', category: 'FUTBOL', count: 1, image: '/trophies/general-harrington9.png' },
  { id: 'fb-11', title: 'Euroleague Kupası', category: 'BASKETBOL', count: 2, image: '/trophies/achievements-img1.png' },
  { id: 'fb-12', title: 'Kadınlar EuroLeague Kupası', category: 'BASKETBOL', count: 2, image: '/trophies/achievements-img2.png' },
];

/**
 * Kart genişlikleri CSS'te değil burada belirleniyor: slayt sayısı görselin ve yazının
 * ne kadar yer bulacağını doğrudan etkiliyor. Mobilde 4 kart sığdırılmaya çalışılınca
 * görsel 38px'e, yazı 0.63rem'e düşüyordu; artık ekran başına daha az kart var.
 */
const SLIDE_BREAKPOINTS = {
  // Mobilde tam sayı: kesirli değerde artan pay slaytın iç boşluğunun altında kalıyor,
  // sonraki kart görünmüyor ve sağda ölü boşluk gibi duruyordu.
  0: { slidesPerView: 3, spaceBetween: 8 },
  480: { slidesPerView: 3, spaceBetween: 10 },
  600: { slidesPerView: 4, spaceBetween: 12 },
  768: { slidesPerView: 4, spaceBetween: 14 },
  1024: { slidesPerView: 5, spaceBetween: 16 },
  1280: { slidesPerView: 6, spaceBetween: 18 },
};

const TrophyAchievements = () => {
  const swiperRef = useRef();
  const [trophies, setTrophies] = useState(FALLBACK_TROPHIES);

  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE}/api/trophies`)
      .then((r) => r.json())
      .then((data) => {
        if (cancelled || !data || !data.success) return;
        const items = (data.items || []).filter((t) => t && t.image && t.title);
        if (items.length === 0) return; // yayında kupa yoksa varsayılan listede kal
        setTrophies(items);
      })
      .catch(() => {});

    return () => { cancelled = true; };
  }, []);

  const handlePrev = () => {
    swiperRef.current?.slidePrev();
  };

  const handleNext = () => {
    swiperRef.current?.slideNext();
  };

  return (
    <section className="trophy-achievements-section h-full py-24">
      <div className="relative w-full flex justify-center">
        {/* Oklar */}
        <button
          className="trophy-arrow absolute top-1/2 -translate-y-1/2 left-1 sm:left-2 md:left-6 z-10 xl:left-20"
          onClick={handlePrev}
          aria-label="Sola Kaydır"
        >
          &#8592;
        </button>

        <div className="md:w-5/6 w-10/12 mx-2 relative ">
          <div className="trophy-achievements-header mb-8 justify-center items-center flex flex-col">
            <h2 className="trophy-title">BAŞARILAR</h2>
          </div>

          <Swiper
            modules={[Navigation, Autoplay]}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            navigation={false}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            spaceBetween={8}
            slidesPerView={3}
            breakpoints={SLIDE_BREAKPOINTS}
            className="trophy-swiper"
          >
            {trophies.map((trophy) => (
              <SwiperSlide key={trophy.id}>
                <div className="trophy-card">
                  <img
                    src={mediaSrc(trophy.image)}
                    alt={trophy.title}
                    className="trophy-img"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="trophy-label">{trophy.title}</div>
                  <div className="trophy-category">{trophy.category}</div>
                  <div className="trophy-count">{trophy.count}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <button
          className="trophy-arrow absolute top-1/2 -translate-y-1/2 right-1 sm:right-2 md:right-6 z-10 xl:right-20"
          onClick={handleNext}
          aria-label="Sağa Kaydır"
        >
          &#8594;
        </button>
      </div>
    </section>
  );
};

export default TrophyAchievements;
